import React, { useState, useEffect, useContext, useMemo } from 'react';
import USBDatePicker from '@usb-shield/react-date-picker';
import down from '../assets/img/down.png';

import { PermissionRoleContext } from '../../components/Hooks/usePermissionRoles';
import { defaultCalendarSettings } from '@usb-shield/react-calendar';
import { endpoints } from '../../../config/connections';
import callApi from '../../components/utilities/callApi';

import {
  USBGrid,
  USBColumn,
  USBCheckbox,
  USBDropdown,
  USBButton,
  USBSelect,
} from '@usb-shield/components-react/dist/cjs';
import { USBTableCompat as USBTable } from '../../components/shared/Table';
import moment from 'moment';
// import Router from 'next/router'
import USBBreadcrumb from '@usb-shield/components-react/dist/cjs/breadcrumb';
import { setUserRole, getQS } from '../../components/utilities/Utils';
import Loader from '../../components/utilities/Loader';
import { DashboardContext } from '../context/DashboardContext';
import { DocContext } from '../context/DocContext';
import { FeatureCategoryContext } from '../../components/Hooks/useFeatureCategories';
import {ExportToExcel} from '../../components/utilities/ExportToExcel';
import './ReportingDashboard.css';
import actionlogo from '../../assets/images/rightArrow.png';
import dateAlertIcon from '../../../assets/img/dateAlert.png';
import portalIndicator from '../../../assets/img/portal.png';
import searchIcon from '../../../assets/img/search.png';
import useUserRole from '../../components/Hooks/use-UserRole';
import USBMenu from '@usb-shield/react-menu';
import AutoCompleteDropdown from '../../components/shared/AutoCompleteDropdown/AutoCompleteDropdown';
import {USBIconRequestDocumentA } from '@usb-shield/react-icons';


export const reuseFilterFn = (reportResultsFull, activeFilters) => {
  let initialData = reportResultsFull;
  if (activeFilters.reportingEntity !== '') {
    initialData = initialData.filter(
      (obj) => {
        if(obj.metadata.reportingEntity !== null && obj.metadata.reportingEntity !== undefined && obj.metadata.reportingEntity !== ''){
          return obj.metadata.reportingEntity === activeFilters.reportingEntity;
        }
      }
    );
  }
  if (activeFilters.parentCompany !== '') {
    initialData = initialData.filter(
      (obj) => {
        if(obj.metadata.parentCompanyName !== null && obj.metadata.parentCompanyName !== undefined && obj.metadata.parentCompanyName !== ''){
          return obj.metadata.parentCompanyName === activeFilters.parentCompany;
        }
      }
    );
  }

  if (activeFilters.asOfDate !== '') {
    initialData = initialData.filter(
      (obj) => {
        if(obj.asOfDate !== null && obj.asOfDate !== undefined && obj.asOfDate !== ''){
          return obj.asOfDate == activeFilters?.asOfDate;
        }
      }
    );
  }
  if (activeFilters.cbDate !== '') {
    
    initialData = initialData.filter(
      (obj) => {
        if(obj.closingBinderDate !== null && obj.closingBinderDate !== undefined && obj.closingBinderDate !== ''){
          return moment(obj.closingBinderDate).format('MM/DD/YYYY') == activeFilters?.cbDate;
        }
      }
    );
  }

  if (activeFilters.submittedDate !== '') {
    initialData = initialData.filter(
      (obj) => {
        if(obj.submittedDate !== null && obj.submittedDate !== undefined && obj.submittedDate !== ''){
          return moment(obj.submittedDate).format('MM/DD/YYYY') === activeFilters?.submittedDate;
        }
      }
    );
  }

  if (activeFilters.requirementName !== '') {
    initialData = initialData.filter(
      (obj) => {
        if(obj.category !== null && obj.category !== undefined && obj.category !== ''){
          return obj.category === activeFilters.requirementName;
        }
      }
    );
  }
  if (activeFilters.dealName !== '') {
    initialData = initialData.filter(
      (obj) => {
        if(obj.metadata.dealName !== null && obj.metadata.dealName !== undefined && obj.metadata.dealName !== ''){
          return obj.metadata.dealName === activeFilters.dealName;
        }
      }
    );
  }
  if (activeFilters.status !== '' && activeFilters.status !== 'Status') {
    initialData = initialData.filter(
      (obj) => {
        if(obj.status !== null && obj.status !== undefined && obj.status !== ''){
          return obj.status === activeFilters.status;
        }
      }
    );
  }
  if (activeFilters.following !== '' && activeFilters.following !== 'Follow') {
    const followvalue = activeFilters.following == 'true' ? true : false;
    initialData = initialData.filter((obj) => obj.following === followvalue);
  }
  if (activeFilters.syndicationFundName !== '') {
    initialData = initialData.filter(
      (obj) => {
        if(obj.metadata.syndicationFundName !== null && obj.metadata.syndicationFundName !== undefined && obj.metadata.syndicationFundName !== ''){
          return obj.metadata.syndicationFundName === activeFilters.syndicationFundName;
        }
      }
    );
  }
  // Data after selecting parent company
  return initialData;
};

export const globalSearchFn = (value, results,dashboardData) => {
  let temp = [];
  if (value !== '') {
    results.forEach((item) => {
      if (
        (
          item.dueDate !== null &&
          item.dueDate !== '' &&
          item?.dueDate?.includes(value) ) ||
        (
          item.category !== null &&
          item.category !== '' &&
          item?.category?.toLowerCase().includes(value.toLowerCase()) ) ||
        (
          item.metadata.reportingEntity !== null &&
          item.metadata.reportingEntity !== '' &&
          item?.metadata?.reportingEntity.toLowerCase().includes(value.toLowerCase())) ||
        (
          item.metadata.dealName !== null &&
          item.metadata.dealName !== '' &&
          item?.metadata?.dealName.toLowerCase().includes(value.toLowerCase())) ||
        (
          item.metadata.parentCompanyName !== null &&
          item.metadata.parentCompanyName !== '' &&
          item?.metadata?.parentCompanyName.toLowerCase().includes(value.toLowerCase())) ||
        (
          item.asOfDate !== null &&
          item.asOfDate !== '' &&
          item?.asOfDate.includes(value)) ||
        (
          item.closingBinderDate !== null &&
          item.closingBinderDate !== '' &&
          item?.closingBinderDate.includes(value)) ||
        ((dashboardData.status=="Submitted") &&
          item.submittedDate !== null &&
          item.submittedDate !== '' &&
          item?.submittedDate.includes(value)) ||
        (
          item.status !== null &&
          item.status !== '' &&
          item?.status.toLowerCase().includes(value.toLowerCase())) ||
        (
          item.metadata.syndicationFundName !== null &&
          item.metadata.syndicationFundName !== '' &&
          item?.metadata?.syndicationFundName.toLowerCase().includes(value.toLowerCase())) ||
        (
          item.metadata.dealId !== null &&
          item.metadata.dealId &&
          item.metadata.dealId !== '' &&
          item?.metadata?.dealId.toLowerCase().includes(value.toLowerCase()))
      ) {
        temp.push(item);
      }
    });
  } else {
    temp = results;
  }
  return temp;
};

export const reuseSearchFn = (value, searchValue, results) => {
  let temp = [];
  if (value !== '') {
    results.forEach((item) => {
      if (
        ((searchValue === 'documentType' || searchValue === '') &&
          item.category !== null &&
          item.category !== undefined &&
          item.category !== '' &&
          item.category.toLowerCase().indexOf(value.toLowerCase()) > -1) ||
        ((searchValue === 'legalEntity' || searchValue === '') &&
          item.metadata.reportingEntity !== null &&
          item.metadata.reportingEntity !== undefined &&
          item.metadata.reportingEntity !== '' &&
          item.metadata.reportingEntity
            .toLowerCase()
            .indexOf(value.toLowerCase()) > -1) ||
        ((searchValue === 'dealName' || searchValue === '') &&
          item.metadata.dealName !== null &&
          item.metadata.dealName !== undefined &&
          item.metadata.dealName !== '' &&
          item.metadata.dealName.toLowerCase().indexOf(value.toLowerCase()) >
            -1) ||
        ((searchValue === 'parentCompany' || searchValue === '') &&
          item.metadata.parentCompanyName !== null &&
          item.metadata.parentCompanyName !== undefined &&
          item.metadata.parentCompanyName !== '' &&
          item.metadata.parentCompanyName
            .toLowerCase()
            .indexOf(value.toLowerCase()) > -1) ||
        ((searchValue === 'asOfDate' || searchValue === '') &&
          item.asOfDate !== null &&
          item.asOfDate !== undefined &&
          item.asOfDate !== '' &&
          item.asOfDate==value) ||
        ((searchValue === 'cbDate' || searchValue === '') &&
          item.closingBinderDate !== null &&
          item.closingBinderDate !== undefined &&
          item.closingBinderDate !== '' &&
          moment(item.closingBinderDate).format('MM/DD/YYYY')==value) ||
        ((searchValue === 'submittedDate' || searchValue === '') &&
          item.submittedDate !== null &&
          item.submittedDate !== undefined &&
          item.submittedDate !== '' &&
          moment(item.submittedDate).format('MM/DD/YYYY')==value) ||
        ((searchValue === 'status' || searchValue === '') &&
          item.status !== null &&
          item.status !== undefined &&
          item.status !== '' &&
          item.status.toLowerCase().indexOf(value.toLowerCase()) > -1) ||
        ((searchValue === 'syndicationFundName' || searchValue === '') &&
          item.metadata.syndicationFundName !== null &&
          item.metadata.syndicationFundName !== undefined &&
          item.metadata.syndicationFundName !== '' &&
          item.metadata.syndicationFundName
            .toLowerCase()
            .indexOf(value.toLowerCase()) > -1) ||
        ((searchValue === 'dealNumber' || searchValue === '') &&
          item.metadata.dealId !== null &&
          item.metadata.dealId !== undefined &&
          item.metadata.dealId !== '' &&
          item.metadata.dealId.startsWith(value))
      ) {
        temp.push(item);
      }
    });
  } else {
    temp = results;
  }
  return temp;
};

export const reuseSortingFn = (sortValue, results) => {
  let tmpResults = [...results];
  if (sortValue === 'fundDesc') {
    tmpResults.sort((a, b) => {
      const nameA =
        a.metadata.syndicationFundName != null
          ? (a.metadata.syndicationFundName + '').toLowerCase()
          : '';
      const nameB =
        b.metadata.syndicationFundName != null
          ? (b.metadata.syndicationFundName + '').toLowerCase()
          : '';
      if (nameA > nameB) {
        return -1;
      }
      if (nameA < nameB) {
        return 1;
      }
      return 0;
    });
  }
  if (sortValue === 'fundAsc') {
    const emptyResults = results.filter((n) => {
      return (
        n.metadata.syndicationFundName == null ||
        n.metadata.syndicationFundName === ''
      );
    });
    const nonEmptyResults = results.filter((n) => {
      return (
        n.metadata.syndicationFundName != null &&
        n.metadata.syndicationFundName !== ''
      );
    });
    nonEmptyResults.sort((a, b) => {
      const nameA =
        a.metadata.syndicationFundName != null
          ? (a.metadata.syndicationFundName + '').toLowerCase()
          : '';
      const nameB =
        b.metadata.syndicationFundName != null
          ? (b.metadata.syndicationFundName + '').toLowerCase()
          : '';
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    emptyResults.sort((a, b) => {
      const nameA =
        a.metadata.dealName != null
          ? (a.metadata.dealName + '').toLowerCase()
          : '';
      const nameB =
        b.metadata.dealName != null
          ? (b.metadata.dealName + '').toLowerCase()
          : '';
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    tmpResults = [...nonEmptyResults, ...emptyResults];
  }
  if (sortValue === 'asOfDateDesc') {
    results.sort((a, b) => {
      const key1 = new Date(a.asofDate);
      const key2 = new Date(b.asofDate);
      if (key1 > key2) {
        return -1;
      }
      if (key1 === key2) {
        return 0;
      }
      return 1;
    });
    tmpResults = [...results];
  }

  if (sortValue === 'asOfDateAsc') {
    results.sort((a, b) => {
      const key1 = new Date(a.asofDate);
      const key2 = new Date(b.asofDate);
      if (key1 < key2) {
        return -1;
      }
      if (key1 === key2) {
        return 0;
      }
      return 1;
    });
    tmpResults = [...results];
  }

  if (sortValue === 'submittedDesc') {
 
    results.sort((a, b) => {

      const key1 =  a.submittedDate ? new Date(a.submittedDate) : new Date(0);
      const key2 =  b.submittedDate ? new Date(b.submittedDate) : new Date(0);
     
      if (key1 > key2) {
        return -1;
      }
      if (key1 === key2) {
        return 0;
      }
      return 1;
    });
    tmpResults = [...results];
  }
  if (sortValue === 'submittedAsc') {
  
    results.sort((a, b) => {
      const key1 =  a.submittedDate ? new Date(a.submittedDate) : new Date(0);
      const key2 =  b.submittedDate ? new Date(b.submittedDate) : new Date(0);
      if (key1 < key2) {
        return -1;
      }
      if (key1 === key2) {
        return 0;
      }
      return 1;
    });
    tmpResults = [ ...results];
  }

  if (sortValue === 'dateDesc') {
    tmpResults = results.sort((a, b) => {

      
      const key1 =  a.dueDate ? new Date(a.dueDate) : new Date(0);
      const key2 =  b.dueDate ? new Date(b.dueDate) : new Date(0);
    
      if (key1 > key2) {
        return -1;
      }
      if (key1 === key2) {
        return 0;
      }
      return 1;
    });
  }
  if (sortValue === 'dateAsc') {
    tmpResults = results.sort((a, b) => {
  
      
      const key1 =  a.dueDate ? new Date(a.dueDate) : new Date(0);
      const key2 =  b.dueDate ? new Date(b.dueDate) : new Date(0);
    
      if (key1 < key2) {
        return -1;
      }
      if (key1 === key2) {
        return 0;
      }
      return 1;
    });
  }
  if (sortValue === 'dealAsc') {
    tmpResults.sort((a, b) => {
      const nameA = (a.metadata.dealName+'').toLowerCase();
      const nameB = (b.metadata.dealName+'').toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }
  if (sortValue === 'dealDesc') {
    tmpResults.sort((a, b) => {
      const nameA = (a.metadata.dealName+'').toLowerCase();
      const nameB = (b.metadata.dealName+'').toLowerCase();
      if (nameA > nameB) {
        return -1;
      }
      if (nameA < nameB) {
        return 1;
      }
      return 0;
    });
  }
  if (sortValue === 'legalAsc') {
    tmpResults.sort((a, b) => {
      const nameA = (a.metadata.reportingEntity+'').toLowerCase();
      const nameB = (b.metadata.reportingEntity+'').toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }
  if (sortValue === 'legalDesc') {
    tmpResults.sort((a, b) => {
      const nameA = (a.metadata.reportingEntity+'').toLowerCase();
      const nameB = (b.metadata.reportingEntity+'').toLowerCase();
      if (nameA > nameB) {
        return -1;
      }
      if (nameA < nameB) {
        return 1;
      }
      return 0;
    });
  }
  if (sortValue === 'docAsc') {
    tmpResults.sort((a, b) => {
      const nameA = (a.category+'').toLowerCase();
      const nameB = (b.category+'').toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  }
  if (sortValue === 'docDesc') {
    tmpResults.sort((a, b) => {
      const nameA = (a.category+'').toLowerCase();
      const nameB = (b.category+'').toLowerCase();
      if (nameA > nameB) {
        return -1;
      }
      if (nameA < nameB) {
        return 1;
      }
      return 0;
    });
  }
  return tmpResults;
};

export const handleSearchChange = (
  value,
  reportResultsFull,
  searchValue,
  setReportResults,
  setDashboardData,
  dashboardData,
  setTotalPages,
  setTotalResults,
  activeFilters,
  sortByValue
) => {
 if (value.toLowerCase() == 'completed' && searchValue == 'status') {
  const activeFiltersTemp = activeFilters;
  activeFiltersTemp.status = 'Completed';
  activeFilters.status= 'Completed';
  sessionStorage.setItem('sessionFilters', JSON.stringify(activeFiltersTemp));
  
  setDashboardData({
    ...dashboardData,
    statusValue: 'Completed',
  });
  window.location.reload();
 }
  const filteredData = reuseFilterFn(reportResultsFull, activeFilters);
  const searchedData = reuseSearchFn(value,searchValue ,filteredData);
  const temp = reuseSortingFn(sortByValue, searchedData);
  setReportResults(temp);
  setTotalResults(temp.length);
  setTotalPages(Math.ceil(temp.length / 10));
  const dashboardDataTemp = dashboardData;
  dashboardDataTemp.search = value;
  setDashboardData(dashboardDataTemp);
  // filterAllClear(setDashboardData)
};

export const sortFilteredData = (
  items,
  reportResults,
  setReportResults,
  setSortByValue,
  setTotalPages,
  setTotalResults,
  sortByList
) => {
  const selectedItem = sortByList.find((sd) => sd.label === items[0]).value;
  const reportResultsTemp = reuseSortingFn(selectedItem, [...reportResults]);
  setReportResults([...reportResultsTemp]);
  setTotalPages(Math.ceil(reportResultsTemp.length / 10));
  setTotalResults(reportResultsTemp.length);
  setSortByValue(selectedItem);
};

/**
 * A callback function that handles the changes from a USBSelect component.
 *
 * @param {React.ChangeEvent<HTMLSelectElement>} changeEvent The change event from the USBSelect component.
 * @param {string} column The name of the column being filtered.
 * @param {import('../context/DashboardContext').ReportingFilters} activeFilters
 * @param {*} setActiveFilters A dispatch action
 * @param {[import('../context/DashboardContext').ReportingData]} reportResultsFull
 * @param {*} setReportResults A dispatch action
 * @param {*} setDashboardData A dispatch action
 * @param {*} dashboardData The dashboard data.
 * @param {string} sortByValue The column name and direction to sort the data.
 * @param {*} setTotalPages A dispatch action
 * @param {*} setTotalResults A dispatch action
 * @param {string} searchValue The current search value.
 * @param {*} loadFilterS The loadFilterS function in the dashboard context.
 * @param {*} // emptyFilters The // emptyFilters function in the dashboard context.
 * @param {*} getAPIResponse The getAPIResponse function in the dashboard context.
 */
export const filterData = (
  changeEvent,
  column,
  setStatusData,
  activeFilters,
  setActiveFilters,
  reportResultsFull,
  setReportResults,
  setDashboardData,
  dashboardData,
  sortByValue,
  setTotalPages,
  setTotalResults,
  searchValue,
  loadFilterS,
  // emptyFilters,
  getAPIResponse,
  setRefreshUI,
  refreshChildren=true
) => {
  const activeFiltersTemp = activeFilters;
  const selectedValue = changeEvent?.inputValue
    ? changeEvent?.inputValue
    : changeEvent?.target?.value;

  if (activeFiltersTemp[column] === selectedValue) {
    return;
  }

  if (column === 'requirementName') {
    activeFiltersTemp.requirementName = selectedValue;
  }
  if (column === 'reportingEntity') {
    activeFiltersTemp.reportingEntity = changeEvent;
    activeFiltersTemp.dealName = '';
    activeFiltersTemp.syndicationFundName = '';
  }
  if (column === 'parentCompany') {
    activeFiltersTemp.parentCompany = changeEvent;
    if(refreshChildren){
    activeFiltersTemp.reportingEntity = '';
    activeFiltersTemp.dealName = '';
    activeFiltersTemp.syndicationFundName = '';
    }
  }
  if (column === 'asOfDate' && (selectedValue?.length == 10 || selectedValue == undefined)) {
    activeFiltersTemp.asOfDate = selectedValue||"";
  }
  if (column === 'cbDate' && (selectedValue?.length == 10 || selectedValue == undefined)) {
    activeFiltersTemp.cbDate = selectedValue||"";
  }
  if (column === 'submittedDate' && (selectedValue?.length == 10 || selectedValue == undefined)) {
    activeFiltersTemp.submittedDate = selectedValue||"";;
  }
  if (column === 'dealName') {
    activeFiltersTemp.dealName = changeEvent;
  }
  if (column === 'status') {
    activeFiltersTemp.status = selectedValue;
    setStatusData(selectedValue);
  }
  if (column === 'followCheck') {
    activeFiltersTemp.following = selectedValue;
  }
  if (column === 'syndicationFundName') {
    activeFiltersTemp.syndicationFundName = changeEvent;
  }

  setActiveFilters(activeFiltersTemp);
  sessionStorage.setItem('sessionFilters', JSON.stringify(activeFiltersTemp));
  setDashboardData({
    search: dashboardData.search,
    dealNameValue: activeFiltersTemp.dealName,
    reportingEntityValue: activeFiltersTemp.reportingEntity,
    parentCompanyValue: activeFiltersTemp.parentCompany,
    asOfDateValue: activeFiltersTemp.asOfDate,
    cbDateValue: activeFilters.cbDate,
    submittedDateValue: activeFiltersTemp.submittedDate,
    requirementNameValue: activeFiltersTemp.requirementName,
    statusValue: activeFiltersTemp.status,
    syndicationfundValue: activeFiltersTemp.syndicationFundName,
    followValue: activeFilters.following,
  });
  const remote_customer = JSON.parse(sessionStorage.getItem('remote_user'))
    ? JSON.parse(sessionStorage.getItem('remote_user')).userID
    : null;
  const view_as = sessionStorage.getItem('view_as')
    ? `${JSON.parse(sessionStorage.getItem('view_as')).bankerId}@cdcemp`
    : null;
  if (column === 'status') {
    if (remote_customer) {
      getAPIResponse(remote_customer, activeFiltersTemp.status, true);
    } else if (view_as) {
      getAPIResponse(view_as, activeFiltersTemp.status);
    } else {
      getAPIResponse(
        sessionStorage.getItem('assignedUser'),
        activeFiltersTemp.status
      );
    }
  } else {
    const filteredResults = reuseFilterFn(reportResultsFull, activeFiltersTemp);
    const searchedData = reuseSearchFn(
      dashboardData.search,
      searchValue,
      filteredResults
    );
    const sortedData = reuseSortingFn(sortByValue, searchedData);
    setReportResults(sortedData);
    setTotalPages(Math.ceil(sortedData.length / 10));
    setTotalResults(sortedData.length);
      setRefreshUI(false)
  }

};

export const tblContentTemplate = (item, filterStatus, setActionsDrop,tempUserRole,setLoading,setCurrentPage,currentPage,includesCBDocs,closingBinderCategoryLookup,statusData) => {
  const docDate = item.dueDate;
  const docdueDate = moment(item.dueDate, 'YYYYMMDD').format('YYYYMMDD');
  let dateHtml;
  let dueHtml = <></>;
  const disabledID = sessionStorage.getItem('userrole') === 'employee' && !sessionStorage.getItem('remote_user') && sessionStorage.getItem('userData') && JSON.parse(sessionStorage.getItem('userData')).emailId ? false : true; 
 
  const today = moment(new Date(), 'YYYYMMDD').format('YYYYMMDD');
  if (docDate != null &&  item?.requirementName?.toLowerCase()!=="construction draw") {
    const days = moment(docdueDate, 'YYYYMMDD').diff(
      moment(today, 'YYYYMMDD'),
      'days'
    );
    if (days === 0 && item.status === 'Not Submitted') {
      dueHtml = <div className="date-details">Due today</div>;
    } else if (days < 0 && item.status === 'Not Submitted') {
      dueHtml = (
        <div className="font-red date-details">
          <span className="date-alert">
            <img src={dateAlertIcon} />
          </span>
          Past due
        </div>
      );
    } else if (days > 0 && item.status !== 'Completed') {
      dueHtml = (
        <div className="date-details">
          Due in&nbsp;
          {days}
          &nbsp;
          {days > 1 ? 'days' : 'day'}
        </div>
      );
    }
    dateHtml = (
      <div>
        {moment(docdueDate).format('MM/DD/YYYY')}
        <div>{dueHtml}</div>
      </div>
    );
  } else dateHtml = '-';

  let dealNametext = '';
  let dealNumberText;
  if (
    (item.metadata.syndicationFundName === '' ||
      item.metadata.syndicationFundName === null || item.metadata.syndicationFundName === undefined) &&
    (item.metadata.dealName === '' || item.metadata.dealName === null || item.metadata.dealName === undefined)
  ) {
    dealNametext = 'Not applicable';
    dealNumberText = '';
  } else if (
    item.metadata.syndicationFundName === '' ||
    item.metadata.syndicationFundName === null ||
    item.metadata.syndicationFundName === undefined
  ) {
    dealNametext = item.metadata.dealName;
    dealNumberText = item.metadata.dealId;
  } else if (
    (item.metadata.dealName === '' || item.metadata.dealName === null || item.metadata.dealName === undefined) &&
    item.metadata.showSyndicationFundInd === true
  ) {
    dealNametext = item.metadata.syndicationFundName;
    dealNumberText = item.metadata.syndicationFund;
  } else if (
    (item.metadata.dealName === '' || item.metadata.dealName === null || item.metadata.dealName === undefined) &&
    item.metadata.showSyndicationFundInd === false
  ) {
    dealNametext = 'Not applicable';
    dealNumberText = '';
  } else if (
    sessionStorage.getItem('userrole') !== 'employee' &&
    item.metadata.showSyndicationFundInd === false
  ) {
    dealNametext = item.metadata.dealName;
    dealNumberText = item.metadata.dealId;
  } else {
    dealNametext = `${item.metadata.dealName} | ${item.metadata.syndicationFundName}`;
    dealNumberText = item.metadata.dealId;
  }

  const legalEntityHtml = item.metadata.reportingEntity;
  const parentCompanyHtml = item.metadata.parentCompanyName;

  let docCategory = '';
  if (item.category === null) {
    docCategory = <div className="empty-div" />;
  } else docCategory = item.category;
  const isClosingBinderCategory = closingBinderCategoryLookup.has((docCategory + '').toLowerCase());
  const docRequirement = item.requirementName;

  const asofDate = item.asOfDate ? item.asOfDate : "-";
  const cbDate =  includesCBDocs && item.category=="Closing Binder" ? item.closingBinderDate ? moment.utc(item.closingBinderDate).format('MM/DD/YYYY') : "N/A" : "N/A"
  
  let asofdateHtml;
  if(includesCBDocs){
    asofdateHtml = <div>
      <div>{asofDate}<hr/>{cbDate}</div>
    </div>
  } else {
    asofdateHtml = <div>{asofDate}</div>;
  }

  const receivedDate = item.submittedDate;
  let receiveddateHtml;
  if (receivedDate != null)
  receiveddateHtml = (
      <div>{moment(item.submittedDate).format('MM/DD/YYYY HH:mm:ss')}</div>
    );
  else receiveddateHtml = <div>-</div>;

  const statusType = item.status;
  let statusHtml = '';
  if (statusType.toLowerCase() === 'needs action')
    statusHtml = (
      <div className="font-red to-uppercase">
        {statusType}
        <span className="notification">#</span>
      </div>
    );
  else if (statusType.toLowerCase() === 'submitted')
    statusHtml = (
      <div className="data-table-cell to-uppercase">
        <div>{statusType}</div>
        {item.submittedDate &&
        item.submittedDate !== '' &&
        item.submittedDate !== null ? (
          <div>{moment(item.submittedDate).format('MM/DD/YYYY')}</div>
        ) : (
          ''
        )}
      </div>
    );
  else
    statusHtml = (
      <div className="data-table-cell to-uppercase">{statusType}</div>
    );
  const follow = (follow, item, setActionsDrop,setLoading,setCurrentPage,currentPage) => {
   
    const data = {
      userId: sessionStorage.getItem('loggedUser'),
      subscribed: follow,
      documentId: item.id,
      emailId: JSON.parse(sessionStorage.getItem('userData')).emailId,
      name:
        JSON.parse(sessionStorage.getItem('userData')).firstName +
        ' ' +
        JSON.parse(sessionStorage.getItem('userData')).lastName,
    };
    if (item.id) {
      setCurrentPage(currentPage);
      const listUrl = `${endpoints.apigee}/document-management/cdc/requirements/v1/requirements-subscribe`;
      callApi
        .postApiLoggedUser(listUrl, data)
        .then((response) => {
          setActionsDrop(item.id);
          setTimeout(() => {
            setLoading(false);
          }, 500);
          
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  const followUp = (id, following,setActionsDrop,setLoading,setCurrentPage,currentPage) => {
    const currentPageTemp=currentPage;
    setLoading(true);

    const maxCount = sessionStorage.getItem('maxCount')
      ? JSON.parse(sessionStorage.getItem('maxCount'))
      : 100;
    const followingCount = sessionStorage.getItem('followingCount')
      ? JSON.parse(sessionStorage.getItem('followingCount'))
      : 0;
    if (followingCount < maxCount) {
      if (following === false && item.id === id) {
        follow(true, item, setActionsDrop,setLoading,setCurrentPage,currentPageTemp);
        following=true;
      } else if (following === true && item.id === id) {
        follow(false, item, setActionsDrop,setLoading,setCurrentPage,currentPageTemp);
        following=false;
      }
    } else if (
      following === false &&
      confirm(
        `You are already following ${maxCount} documents. Are you sure you want to follow?`
      )
    ) {
      if (following === false && item.id === id) {
        follow(true, item, setActionsDrop,setLoading,setCurrentPage,currentPageTemp);
      }
    } else {
      if (following === true && item.id === id) {
        follow(false, item, setActionsDrop,setLoading,setCurrentPage,currentPageTemp);
      }
    }
  
    setActionsDrop(item.id);
    setTimeout(() => {
      setLoading(false);
    }, 100);

  };
  const docId = item.id;
  let tableDataObject = {
    first: dateHtml,
    second: (
      <div>
        <div className="span-bold">{dealNametext}</div>
        <div className="data-table-subcell">{dealNumberText}</div>
      </div>
    ),
    third: (
      <div>
        <div className="span-bold">{parentCompanyHtml}</div>
        <div className="data-table-subcell">{legalEntityHtml}</div>
      </div>
    ),
    fourth: (
      <div className="data-table-cell">
        <div className="span-bold">{docCategory}</div>
        <div className="data-table-subcell">{docRequirement}</div>
        {item.portalSubmitted ? (
          <div className="expand-column-portal">
            <div className="portal-indicator">
              <img src={portalIndicator} />
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    ),
    fifth: asofdateHtml, }
  const rowHref = isClosingBinderCategory ? `/ClosingBinders/Portfolio/Requirements?id=${docId}` : `/RequirementDetails?id=${docId}`;
  if (statusType != 'Not Submitted' || filterStatus == 'Status' || statusData == 'Status') {
    if(!sessionStorage.getItem('remote_user') && tempUserRole === 'employee'){
      return { ...tableDataObject,
        sixth: receiveddateHtml,
        seventh: statusHtml,
        eighth: (
          <div>
            <div className="expand-column" data-testid="chck-box" title={
            disabledID
                ? 'User must have assigned portfolio to follow'
                : 'Click here to Follow'
            }>
              <div style={ disabledID ? {
                  pointerEvents: 'none', 
                  cursor: 'not-allowed', 
                  opacity: 0.5,          
                } : {}}>
             <USBCheckbox
                handleChange={() => {
                  followUp(item.id, item.following,setActionsDrop,setLoading,setCurrentPage,currentPage);
                  item.following=!item.following;
                }
                }
                labelText=""
                subLabel=""
                initIsChecked={item.following}
                // initIsDisabled={disabledID}
                ariaLabelledBy="mark-final"
                tooltip={true}
              />
              </div>
            </div>
          </div>
        ),
        rowHref,
      };
    }
    return {
      ...tableDataObject,
      sixth: receiveddateHtml,
        seventh: statusHtml,
        rowHref,
    }
  }
  if(!sessionStorage.getItem('remote_user') && tempUserRole === 'employee'){
    return {
      ...tableDataObject,
      sixth: statusHtml,
      seventh: (
        <div>
          <div className="expand-column" data-testid="chck-box" title={
            disabledID
                ? 'User must have assigned portfolio to follow'
                : 'Click here to Follow'
            } >
          <div style={ disabledID ? {
              pointerEvents: 'none', 
              cursor: 'not-allowed', 
              opacity: 0.5,          
            } : {}}>
              <USBCheckbox
                handleChange={() => {
                  followUp(item.id, item.following,setActionsDrop,setLoading,setCurrentPage,currentPage);
                  item.following=!item.following;
                }
                }
                labelText=""
                subLabel=""
                initIsChecked={item.following}
                // initIsDisabled={disabledID}
                ariaLabelledBy="mark-final"
                tooltip={true}
              />
            </div>
          </div>
        </div>
      ),
      rowHref,
    };
  }
  return {
    ...tableDataObject,
    sixth: statusHtml,
    rowHref,
  }
};

export const downloadDataCheck = (reportResultsFull) => {
  let count = 0;
  reportResultsFull.forEach((item) => {
    const dueDate = item.dueDate.split('T');
    const docdueDate = moment(dueDate, 'YYYYMMDD').format('YYYYMMDD');
    const today = moment(new Date(), 'YYYYMMDD').format('YYYYMMDD');
    if (docdueDate != null) {
      const days = moment(docdueDate, 'YYYYMMDD').diff(
        moment(today, 'YYYYMMDD'),
        'days'
      );
      if (days <= -30 && item.status === 'Not Submitted') {
        count += 1;
      }
    }
  });
  if (count > 0) {
    return true;
  }
  return false;
};

const ReportingDashboard = () => {
      
  const {permissionDetails}=useContext(PermissionRoleContext);
  const { categories } = useContext(FeatureCategoryContext);
  const [searchItemsList, setSearchItemsList] = useState([])
  const [searchMenuKey, setSearchMenuKey] = useState(0);
  const [employeeFlag, setEmployeeFlag] = useState(false);
  // const [portalAdmin, setPortalAdmin] = useState(false)
  const [tempSessions, setTempSessions] = useState(false);
  const [rangeArray, setRangeArray] = useState(['25', '50', '75', '100']);
  const [pageCount, setPageCount] = useState(25);
  const [refreshUI,setRefreshUI] = useState(false)
  // history hook removed (v6 migration): useNavigate inside routed components if navigation is needed
  const {
    reportResults,
    setReportResults,
    reportResultsFull,
    reportingEntity,
    dealName,
    requirementName,
    statusDrop,
    parentCompany,
    submittedDate,
    asOfDate,
    loading,
    setLoading,
    dashboardData,
    setDashboardData, // statusValue, setStatusValue,
    syndicationFund,
    sortBy,
    searchData,
    totalPages,
    setTotalPages,
    totalResults,
    setTotalResults,
    activeFilters,
    setActiveFilters,
    loadFilterS,
    getAPIResponse,
    // emptyFilters,
    sortByValue,
    setSortByValue,
    searchValue,
    setSearchValue,
    clearFilter,
    // clearFilterForReports,
    showSyndication,
    setReportingEntity,
    followCheck,
    parentCompanyCpy,
    reportingEntityCpy,
    dealNameCpy,
    syndicationFundCpy,
  } = useContext(DashboardContext);
  const [actionsDrop, setActionsDrop] = useState();
  const { assignedUserName, servicingUserRole, setCurrentMenu } =
    useContext(DocContext);
  const [filterReportingEntity, setFilterEntity] = useState([]);
  const [filterDealName, setfilterDealName] = useState([]);
  const [filterParentCompany, setfilterParentCompany] = useState([]);
  const [filterFundName, setfilterFundName] = useState([]);
  const [contentOpen, setContentOpen] = useState(false);
  const [contentOpenDeal, setcontentOpenDeal] = useState(false);
  const [contentOpenParent, setcontentOpenParent] = useState(false);
  const [contentOpenFund, setcontentOpenFund] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageTemp, setCurrentPageTemp] = useState(1);
  const [statusData, setStatusData] = useState('');
  const tempUserRole = useUserRole();
  const pccpy = JSON.stringify(parentCompanyCpy);

  const closingBinderCategoryLookup = useMemo(() => {
    const closingBinderCategory = categories.find((category) => category.key === 'closingBinderCategory');
    const closingBinderItems = closingBinderCategory?.items || [];
    return new Set(closingBinderItems.map((item) => item.toLowerCase()));
  }, [categories]);

  useEffect(() => {
    document.addEventListener('click', handleClickDropdown, true);

  }, []);

  useEffect(() => {
    if (getQS('a') === 'c') {
      setTempSessions(true);
    }
      // setCurrentMenu('portfolio');
      setUserRole();
      if (JSON.parse(sessionStorage.getItem('remote_user'))) {
        getAPIResponse(
          JSON.parse(sessionStorage.getItem('remote_user')).userID,
          'Not Submitted',
          true
        );
      } else if (sessionStorage.getItem('view_as')) {
        getAPIResponse(
          `${JSON.parse(sessionStorage.getItem('view_as')).bankerId}@cdcemp`,
          'Submitted',
          true
        );
      } else {
        getAPIResponse(sessionStorage.getItem('assignedUser'), ''); // , false, true
      }

      if (
        sessionStorage.getItem('userrole') === 'employee' ||
        servicingUserRole === 'employee'
      ) {
        setEmployeeFlag(true);
      }
  }, []);

  const includesCBDocs = reportResultsFull.filter((item)=>item.category=="Closing Binder").length > 0 ? true : false; 

  const paginationtableData = (reportResults, filterStatus,tempUserRole,setLoading,setActionsDrop,setCurrentPage,currentPage,closingBinderCategoryLookup) => {
    let paginationData = [];

    if (reportResults.length != 0) {
      paginationData = [];
      reportResults.map((item) => {
        paginationData.push(
          tblContentTemplate(item, filterStatus, setActionsDrop,tempUserRole,setLoading,setCurrentPage,currentPage,includesCBDocs,closingBinderCategoryLookup,statusData)
        );
      });
    }

    return paginationData;
  };

  const defaultContent = {
    dateInput: {
      calendarButtonAriaLabel: 'Choose date',
      helperText: 'mm/dd/yyyy',
      helperTextOptional: 'Optional',
      labelText: 'Received date',
      labelText2: 'As of Date',
      errorMessages: {
        default: 'Please enter a valid date.',
        118: 'Please enter a valid date.',
        201: 'Please enter a valid date.',
        202: 'Date should be in the past.',
        203: 'Date should be in the future.',
        221: 'Enter no more than 10 characters.',
        213: 'Enter numbers only.',
        224: '(Optional field)',
        228: "That date isn't available. Please try again.",
      },
    },
  };

  const defaultSettingsDateInput = {
    initValue: activeFilters?.submittedDate?.length==10 ? activeFilters?.submittedDate : undefined,
    isDateOfBirth: true,
    minimumAge: 0,
    maximumAge: 20,
    maxlength: 20,
    showRenderCount: false,
    inputName: 'date-picker_single-date--default',
    isDisabled: false,
    isOptional: false,
    isReadOnly: false,
    dataTestId: null,
  };

  const defaultSettingsCalendar = {
    areBankHolidaysDisabled: defaultSettingsDateInput.isDateOfBirth
      ? false
      : true,
    areWeekendsDisabled: defaultSettingsDateInput.isDateOfBirth ? false : true,
    occurrence: defaultSettingsDateInput.isDateOfBirth ? 'past' : 'future',
    numberOfYearsToShow: '20',
  };

  const defaultContent1 = {
    dateInput: {
      calendarButtonAriaLabel: 'Choose date',
      helperText: 'mm/dd/yyyy',
      helperTextOptional: 'Optional',
      labelText: 'As of Date',
      errorMessages: {
        default: 'Please enter a valid date.',
        118: 'Please enter a valid date.',
        201: 'Please enter a valid date.',
        202: 'Date should be in the past.',
        203: 'Date should be in the future.',
        221: 'Enter no more than 10 characters.',
        213: 'Enter numbers only.',
        224: '(Optional field)',
        228: "That date isn't available. Please try again.",
      },
    },
  };

  const defaultSettingsDateInput1 = {
    initValue:  activeFilters?.asOfDate || undefined,
    isDateOfBirth: true,
    minimumAge: 0,
    maximumAge: 20,
    maxlength: 20,
    showRenderCount: false,
    inputName: 'date-picker_single-date--default1',
    isDisabled: false,
    isOptional: false,
    isReadOnly: false,
    dataTestId: null,
  };

  const defaultSettingsCalendar1 = {
    areBankHolidaysDisabled: defaultSettingsDateInput1.isDateOfBirth
      ? false
      : true,
    areWeekendsDisabled: defaultSettingsDateInput1.isDateOfBirth ? false : true,
    occurrence: defaultSettingsDateInput1.isDateOfBirth ? 'past' : 'future',
    numberOfYearsToShow: '20',
  };

  const updateRangeArray = (pageCountTmp) => {
    let dropdownSpans = document.getElementsByClassName('dropdown__btn-selection selected')
    if(dropdownSpans && reportResults && reportResults.length>24){
      dropdownSpans[0].childNodes[0].data = dropdownSpans[1].childNodes[0].data = pageCountTmp
      setPageCount(pageCountTmp)
    }
  };

  const loadByEntityName = (
    item,
    columnName,
    activeFilters,
    setActiveFilters,
    reportResultsFull,
    setReportResults,
    setDashboardData,
    dashboardData,
    sortByValue,
    setTotalPages,
    setTotalResults,
    searchValue,
    loadFilterS,
    // emptyFilters,
    getAPIResponse,
    refreshChildren=true
  ) => {
    
    if(refreshChildren){
    setRefreshUI(true)}
    filterData(
      item,
      columnName,
      setStatusData ,
      activeFilters,
      setActiveFilters,
      reportResultsFull,
      setReportResults,
      setDashboardData,
      dashboardData,
      sortByValue,
      setTotalPages,
      setTotalResults,
      searchValue,
      loadFilterS,
      // emptyFilters,
      getAPIResponse,
      setRefreshUI,
      refreshChildren
    );
    setContentOpen(false);
    setcontentOpenDeal(false);
    setcontentOpenParent(false);
    setcontentOpenFund(false);
  };

    const downloadPastDueReporting = () => {
    let tempdata = [];
    const now = moment();
    reportResultsFull.forEach((item) => {
      const dueDate = item.dueDate.split('T');
      const docdueDate = moment(dueDate, 'YYYYMMDD').format('YYYYMMDD');
      const today = moment(new Date(), 'YYYYMMDD').format('YYYYMMDD');
      if (docdueDate != null) {
        const days = moment(docdueDate, 'YYYYMMDD').diff(
          moment(today, 'YYYYMMDD'),
          'days'
        );
        if (days <= -30 && item.status === 'Not Submitted') {
          tempdata.push({
            REPORT_DATE_OF_CREATION: now.format('MMM DD, YYYY'),
            DUE_DATE: moment(dueDate[0]).format('MMM DD, YYYY'),
            AS_OF_DATE: moment(item.asOfDate).format('MMM DD, YYYY'),
            DEAL_NAME: item.metadata.dealName,
            DEAL_NUMBER: item.metadata.dealId,
            PARENT_COMPANY: item.metadata.parentCompanyName,
            SUBMITTED_DATE: item.submittedDate,
            LEGAL_ENTITY: item.metadata.reportingEntity,
            DOCUMENT_TYPE: item.category,
            'DOCUMENT_SUBTYPE(CATEGORY)': item.requirementName,
            STATUS: item.status,
            ...(sessionStorage.getItem('userrole') === 'employee'
              ? { FUND_NAME: item.metadata.syndicationFundName }
              : ''),
          });
        }
      }
    });
    ExportToExcel(
      Object.values(tempdata),
      'Past_Due_Report',
    );
  }

  const downloadAllReporting = () => {
    let tempdata = [];
    const now = moment();
    reportResults.forEach((item) => {
      tempdata.push({
        REPORT_DATE_OF_CREATION: now.format('MMM DD, YYYY'),
        DUE_DATE: moment(item.dueDate).format('MMM DD, YYYY'),
        AS_OF_DATE: moment(item.asOfDate).format('MMM DD, YYYY'),
        DEAL_NAME: item.metadata.dealName,
        DEAL_NUMBER: item.metadata.dealId,
        PARENT_COMPANY: item.metadata.parentCompanyName,
        SUBMITTED_DATE: item.submittedDate,
        LEGAL_ENTITY: item.metadata.reportingEntity,
        DOCUMENT_TYPE: item.category,
        'DOCUMENT_SUBTYPE(CATEGORY)': item.requirementName,
        STATUS: item.status,
        ...(sessionStorage.getItem('userrole') === 'employee'
          ? { FUND_NAME: item.metadata.syndicationFundName }
          : ''),
      });
    });
    ExportToExcel(
      Object.values(tempdata),
      'My_Portfolio_Report',
    );
  }

  const compNameKepress = (event, item) => {
    if (event.keyCode === 27) {
      setContentOpen(false);
      setcontentOpenParent(false);
      setcontentOpenFund(false);
      setcontentOpenDeal(false);
    }
  };
  const searchDropFilter = (value) => {
    setcontentOpenParent(false);
    setcontentOpenDeal(false);
    setcontentOpenFund(false);
    let temp = [];
    setFilterEntity([]);
    setActiveFilters((prev)=>{
      return {...prev,
        reportingEntity : value
      }
    })
    if (value !== '' || value.length !== 0) {
      reportingEntity.forEach((item) => {
        if (
          (item.content !== null && item.content !== '') ||
          (item.value !== null && item.value !== '')
        ) {
          const itemValue = '' + item.value;
          const itemContent = '' + item.content;
          const inputValue = '' + value;
          if (
            itemValue.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 ||
            itemContent.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
          ) {
            temp.push(item);
            setContentOpen(true);
          }
        } else {
          setContentOpen(false);
        }
      });
      setFilterEntity(temp);
    } else {
      temp = reportingEntity;
      setFilterEntity(temp);
      loadByEntityName(
        '',
        'reportingEntity',
        activeFilters,
        setActiveFilters,
        reportResultsFull,
        setReportResults,
        setDashboardData,
        dashboardData,
        sortByValue,
        setTotalPages,
        setTotalResults,
        searchValue,
        loadFilterS,
        // emptyFilters,
        getAPIResponse
      );
    }
    setContentOpen(true);
  };
  const toggleContent = () => {
    setFilterEntity(reportingEntityCpy);
    if (contentOpen) {
      setContentOpen(false);
    } else {
      setContentOpen(true);
      setcontentOpenDeal(false);
      setcontentOpenFund(false);
      setcontentOpenParent(false);
    }
  };

  const handleClickDropdown = (event) => {
    if (
      event.srcElement.className !== 'down-image' &&
      event.srcElement.className !== 'auto-dropdown-items'
    ) {
      setContentOpen(false);
      setcontentOpenDeal(false);
      setcontentOpenFund(false);
      setcontentOpenParent(false);
    }
  };

  const toggleContentDealName = () => {
    setfilterDealName(dealNameCpy);
    if (contentOpenDeal) {
      setcontentOpenDeal(false);
    } else {
      setcontentOpenDeal(true);
      setContentOpen(false);
      setcontentOpenFund(false);
      setcontentOpenParent(false);
    }
  };
  const toggleContentFund = () => {
    setfilterFundName(syndicationFundCpy);
    if (contentOpenFund) {
      setcontentOpenFund(false);
    } else {
      setcontentOpenFund(true);
      setcontentOpenDeal(false);
      setContentOpen(false);
      setcontentOpenParent(false);
    }
  };
  const searchDropFilterFund = (value) => {
    setContentOpen(false);
    setcontentOpenDeal(false);
    setcontentOpenParent(false);
    let temp = [];
    setfilterFundName([]);
    setActiveFilters((prev)=>{
      return {...prev,
        syndicationFundName : value
      }
    })
    if (value !== '' || value.length !== 0) {
      syndicationFund.forEach((item) => {
        if (
          (item.content !== null && item.content !== '') ||
          (item.value !== null && item.value !== '')
        ) {
          const itemValue = '' + item.value;
          const itemContent = '' + item.content;
          const inputValue = '' + value;
          if (
            itemValue.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 ||
            itemContent.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
          ) {
            temp.push(item);
            setcontentOpenFund(true);
          }
        } else {
          setcontentOpenFund(false);
        }
      });
      setfilterFundName(temp);
    } else {
      temp = syndicationFund;
      setfilterFundName(temp);
      loadByEntityName(
        '',
        'syndicationFundName',
        activeFilters,
        setActiveFilters,
        reportResultsFull,
        setReportResults,
        setDashboardData,
        dashboardData,
        sortByValue,
        setTotalPages,
        setTotalResults,
        searchValue,
        loadFilterS,
        // emptyFilters,
        getAPIResponse
      );
    }

    setcontentOpenFund(true);
  };

  const searchDropFilterDeal = (value) => {
    setContentOpen(false);
    setcontentOpenParent(false);
    setcontentOpenFund(false);
    let temp = [];
    setfilterDealName([]);
    setActiveFilters((prev)=>{
      return {...prev,
        dealName : value
      }
    })
    if (value !== '' || value.length !== 0) {
      dealName.forEach((item) => {
        if (
          (item.content !== null && item.content !== '') ||
          (item.value !== null && item.value !== '')
        ) {
          const itemValue = '' + item.value;
          const itemContent = '' + item.content;
          const inputValue = '' + value;
          if (
            itemValue.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 ||
            itemContent.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
          ) {
            temp.push(item);
            setcontentOpenDeal(true);
          }
        } else {
          setcontentOpenDeal(false);
        }
      });
      setfilterDealName(temp);
    } else {
      temp = dealName;
      setfilterDealName(temp);
      loadByEntityName(
        '',
        'dealName',
        activeFilters,
        setActiveFilters,
        reportResultsFull,
        setReportResults,
        setDashboardData,
        dashboardData,
        sortByValue,
        setTotalPages,
        setTotalResults,
        searchValue,
        loadFilterS,
        // emptyFilters,
        getAPIResponse
      );
    }

    setcontentOpenDeal(true);
  };
  const toggleContentParentCompany = () => {
    setfilterParentCompany(parentCompanyCpy);
    if (contentOpenParent) {
      setcontentOpenParent(false);
    } else {
      setcontentOpenParent(true);
      setContentOpen(false);
      setcontentOpenDeal(false);
      setcontentOpenFund(false);
    }

    // setContentOpen(true);
  };
  const searchDropFilterParentCompany = (value) => {
    setContentOpen(false);
    setcontentOpenDeal(false);
    setcontentOpenFund(false);
    let temp = [];
    setfilterParentCompany([]);
    setActiveFilters((prev)=>{
      return {...prev,
        parentCompany : value
      }
    })
    if (value !== '' || value.length !== 0) {
      parentCompany.forEach((item) => {
        if (
          (item.content !== null && item.content !== '') ||
          (item.value !== null && item.value !== '')
        ) {
          const itemValue = '' + item.value;
          const itemContent = '' + item.content;
          const inputValue = '' + value;
          if (
            itemValue.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 ||
            itemContent.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
          ) {
            temp.push(item);
            setcontentOpenParent(true);
          }
        } else {
          setcontentOpenParent(false);
        }
      });
      setfilterParentCompany(temp);
    } else {
      temp = parentCompany;
      setfilterParentCompany(temp);
      loadByEntityName(
        '',
        'parentCompany',
        activeFilters,
        setActiveFilters,
        reportResultsFull,
        setReportResults,
        setDashboardData,
        dashboardData,
        sortByValue,
        setTotalPages,
        setTotalResults,
        searchValue,
        loadFilterS,
        // emptyFilters,
        getAPIResponse
      );
    }

    setcontentOpenParent(true);
  };

  const searchDrop = (items) => {
    const filterTemp = {
      ...activeFilters,
      requirementName: '',
      reportingEntity: '',
      parentCompany: '',
      asOfDate: '',
      cbDate: '',
      submittedDate: '',
      requirementNameReport: '',
      reportingEntityReport: '',
      asOfDateReport: '',
      submittedDateReport: '',
      dealName: '',
      dealId:'',
      syndicationFundName: '',
      following: '',
    };
    const dashboardTemp = {
      ...dashboardData,
      search: '',
      reportingEntityValue: '',
      parentCompanyValue: '',
      asOfDateValue: '',
      cbDateValue:'',
      submittedDateValue: '',
      dealNameValue: '',
      dealIdValue:'',
      requirementNameValue: '',
      reportingEntityValueReport: '',
      asOfDateValueReport: '',
      submittedDateValueReport: '',
      requirementNameValueReport: '',
      syndicationfundValue: '',
      followingValue: '',
    };
  setDashboardData(dashboardTemp)
  setActiveFilters(filterTemp)
  sessionStorage.setItem('sessionFilters', JSON.stringify(filterTemp));
  handleSearchChange(
    '',
    reportResultsFull,
    searchValue,
    setReportResults,
    setDashboardData,
    dashboardTemp,
    setTotalPages,
    setTotalResults,
    filterTemp,
    sortByValue
  )
  const selectedItem = searchData.find((sd) => sd.label === items[0]).value;
  let searchList = [];
  if(selectedItem === 'status'){
      searchList = [
      {  term: 'Not Submitted' },
      { term: 'Submitted' },
      { term: 'Under Review' },
      { term: 'Needs Action' },
      { term: 'Completed' },]
    }
  
  reportResultsFull.forEach((item)=>{
     if(selectedItem === 'dealName' || selectedItem === 'syndicationFundName'){
      searchList.push({term : item.metadata[selectedItem]});
    } else if(selectedItem === 'legalEntity'){
      searchList.push({term : item.metadata.reportingEntity});
    } else if(selectedItem === 'parentCompany'){
      searchList.push({term : item.metadata.parentCompanyName});
    } else if(selectedItem === 'documentType'){
      searchList.push({term : item.category});
    } else if(selectedItem === 'dealNumber'){
      searchList.push({term : ""+item.metadata.dealId});
    }
  });
  searchList = searchList.filter(item => item.term !== null && item.term !== undefined && item.term !== '' && item.term !== 'null' && item.term !== 'undefined');
  searchList = [...new Set(searchList.map(item => JSON.stringify(item)))].map(item => JSON.parse(item)).sort((a, b) => {
    const termA = (a.term || '').toLowerCase();
    const termB = (b.term || '').toLowerCase();
    return termA.localeCompare(termB);
  });
  setSearchItemsList(searchList);
  setSearchValue(selectedItem);
};
  
  return (
    <>
      <USBGrid addClasses="content-frame">
        <USBColumn largeSpan={16}>
          {sessionStorage.getItem('remote_user') ? (
            <div className="warning-panel-remote">
              You are impersonating the user:{' '}
              {JSON.parse(sessionStorage.getItem('remote_user')).firstName}{' '}
              {JSON.parse(sessionStorage.getItem('remote_user')).lastName}. To
              exit, click the 'Exit User' link above.
            </div>
          ) : (
            ''
          )}
        </USBColumn>



        <USBColumn largeSpan={16}>
          {sessionStorage.getItem('filesToCopy') ? (
            <div className="warning-panel-remote">
              Please select the Closing Binders requirement to paste the {(sessionStorage.getItem('filesToCopy')?.split(",")?.length)} selected documents.{' '}

              To cancel copying, click &nbsp;    

                            <USBButton
                                size="small"
                                variant='secondary'
                                handleClick={
                                    () => { sessionStorage.removeItem('filesToCopy'); sessionStorage.removeItem('pastedRequirementId'); sessionStorage.removeItem('pasted'); window.location.reload(); }
                                }
                                ariaLabel='Cancel Copy'
                            >
                                Cancel
                            </USBButton>

             
            </div>
          ) : (
            ''
          )}
        </USBColumn>

        



        <USBColumn largeSpan={8}>
          <USBBreadcrumb
            id="portfolio"
            text="Reporting Dashboard"
            breadcrumbs={[
              {
                id: 1,
                text: 'My Portfolio',
                href: '/ReportingDashboard',
              },
            ]}
          />
        </USBColumn>
        <USBColumn largeSpan={8}>
          { <div className="search-frame-portfolio">
            <div className="search-section-portfolio">
            <USBMenu key={searchMenuKey} id='globalSearchDropDown' type='single'>
                <USBMenu.Button>
                  {searchData.find((sd) => sd.value === searchValue)?.label || 'Search by'}
                </USBMenu.Button>
                <USBMenu.List onChange={(items)=>{searchDrop(items)}}>
                    {searchData.map((item) => {
                      return (
                        <USBMenu.Item key={item.label}>
                          {item.label}
                        </USBMenu.Item>
                      );
                    })}
                </USBMenu.List>
            </USBMenu>
              
              { searchValue != 'asOfDate' && searchValue != 'cbDate' && searchValue != 'submittedDate' ? (
                searchItemsList.length > 0 && <AutoCompleteDropdown
                  key={searchItemsList}
                  onItemSelect={(e) => {
                    setDashboardData((prev)=>{
                        return {...prev,
                          search : e.term
                        }
                      })
                    if(searchValue === 'status'){
                      const activeFiltersTemp = { ...activeFilters, status: e.term };
                      setActiveFilters(activeFiltersTemp);
                      sessionStorage.setItem('sessionFilters', JSON.stringify(activeFiltersTemp));
                      const remote_customer = JSON.parse(sessionStorage.getItem('remote_user'))
                      ? JSON.parse(sessionStorage.getItem('remote_user')).userID
                      : null;
                    const view_as = sessionStorage.getItem('view_as')
                      ? `${JSON.parse(sessionStorage.getItem('view_as')).bankerId}@cdcemp`
                      : null;
                      if (remote_customer) {
                        getAPIResponse(remote_customer, e.term, true);
                      } else if (view_as) {
                        getAPIResponse(view_as, e.term);
                      } else {
                        getAPIResponse(
                          sessionStorage.getItem('assignedUser'),
                          e.term
                        );
                      }
                    } else{
                      handleSearchChange(
                        e.term,
                        reportResultsFull,
                        searchValue,
                        setReportResults,
                        setDashboardData,
                        dashboardData,
                        setTotalPages,
                        setTotalResults,
                        activeFilters,
                        sortByValue
                      )
                    }
                    }}
                  comboboxId="combobox"
                  autocompleteInputId="autocomplete-input"
                  listboxID="listbox"
                  arrowId="combobox-arrow"
                listItems={searchItemsList}
                label = ''
              />) : (<USBDatePicker
                  key={searchValue}
                  id="asofdate"
                  inputName="asofdate"
                  initValue={activeFilters.asOfDate || undefined}
                  labelText2="Select date"
                  statusUpdateCallback={(e) => {
                    loadByEntityName(
                      activeFilters.parentCompany,
                      'parentCompany',
                      activeFilters,
                      setActiveFilters,
                      reportResultsFull,
                      setReportResults,
                      setDashboardData,
                      dashboardData,
                      sortByValue,
                      setTotalPages,
                      setTotalResults,
                      searchValue,
                      loadFilterS,
                      // emptyFilters,
                      getAPIResponse,
                      false
                    );


                    // if(e.event=="onChange" ||e.event=="dynamicValue")
                    filterData(
                      e,
                      searchValue,
                      setStatusData,
                      activeFilters,
                      setActiveFilters,
                      reportResultsFull,
                      setReportResults,
                      setDashboardData,
                      dashboardData,
                      sortByValue,
                      setTotalPages,
                      setTotalResults,
                      searchValue,
                      loadFilterS,
                      // emptyFilters,
                      getAPIResponse,
                      setRefreshUI
                    );
                  }
                  }
                  settings={{
                    dateInput: {
                      ...defaultSettingsDateInput1,
                    },
                    calendar: {
                      id: 'datepicker',
                      ...defaultCalendarSettings,
                      ...defaultSettingsCalendar1,
                      occurrence: 'both',
                      numberOfYearsToShow: '20',
                      labelText: 'Select date',
                    },
                  }}
                  content={{
                    dateInput: {
                      calendarButtonAriaLabel: 'Choose date',
                      helperText: 'mm/dd/yyyy',
                      helperTextOptional: 'Optional',
                      labelText: 'Select date',
                      errorMessages: {
                        default: 'Please enter a valid date.',
                        118: 'Please enter a valid date.',
                        201: 'Please enter a valid date.',
                        202: 'Date should be in the past.',
                        203: 'Date should be in the future.',
                        221: 'Enter no more than 10 characters.',
                        213: 'Enter numbers only.',
                        224: '(Optional field)',
                        228: "That date isn't available. Please try again.",
                      },
                    },
                    labelText: 'Start date',
                    inputName: 'asofdate',
                  }}
                />)}
            </div>
          </div>}
        </USBColumn>
      </USBGrid>
      { !permissionDetails.includes("portfolio") && !loading ? (<>Access Denied</>): 
      (  <USBGrid addClasses="content-frame content-bg">
        <USBColumn largeSpan={16}>
          {loading ? <Loader /> : null}
          {refreshUI ? <Loader /> : null}
          {/* {/* Temp method to set session values in local dev */}
          {tempSessions === true ? (
            <button
              type="button"
              onClick={null}
              style={{
                padding: '4px',
                color: '#ffffff',
                backgroundColor: '#0a41c5',
                border: '1px solid #0a41c5',
                fontFamily: "U.S. Bank Circular",
                borderRadius: '4px',
                marginLeft: '4px',
                position: 'fixed',
                zIndex: '100001',
              }}
            >
              Set Session
            </button>
          ) : (
            ''
          )}
          <h1 className="heading-h1">
            {assignedUserName.firstName === 'You' &&
            !sessionStorage.getItem('remote_user') &&
            !sessionStorage.getItem('view_as') ? (
              'My Portfolio'
            ) : sessionStorage.getItem('remote_user') ? (
              <>
                <span className="span-bold">
                  {JSON.parse(sessionStorage.getItem('remote_user')).firstName}&nbsp;  
                  {JSON.parse(sessionStorage.getItem('remote_user')).lastName}
                </span>
                  &rsquo;s&nbsp;Portfolio
              </>
              ) : sessionStorage.getItem('view_as') ? (
              <>
                <span className="span-bold">
                  {JSON.parse(sessionStorage.getItem('view_as')).userName}
                </span>
                  &rsquo;s&nbsp;Portfolio
              </>
            ) : (
              <>
                <span className="span-bold">
                  {assignedUserName.firstName}
                  &nbsp;
                  {assignedUserName.lastName}
                </span>
                &rsquo;s&nbsp;Portfolio
              </>
            )}
          </h1>
          <div className="page-details-wrap">
            <div className="page-details-container">
              You&apos;ll see all of the open reporting requirements for
              your&nbsp;
              {(employeeFlag ||
                servicingUserRole === 'vendorsiteadmin' ||
                servicingUserRole === 'vendorcontributor') &&
              !JSON.parse(sessionStorage.getItem('remote_user'))
                ? 'customers'
                : 'organization'}
              &nbsp;listed here.&nbsp;
              {(employeeFlag ||
                servicingUserRole === 'vendorsiteadmin' ||
                servicingUserRole === 'vendorcontributor') &&
              !JSON.parse(sessionStorage.getItem('remote_user')) ? (
                <span className="page-details-inline">
                  Use the&nbsp;
                  <span className="span-bold">Parent company</span>
                  &nbsp;filter to view requirements for a specific organization.
                </span>
              ) : (
                ''
              )}
              <div
                className={`${
                  employeeFlag ||
                  servicingUserRole === 'vendorsiteadmin' ||
                  servicingUserRole === 'vendorcontributor'
                    ? 'page-detail'
                    : 'page-details-inline'
                }`}
              >
                Select a reporting requirement to view, upload or download
                documents.&nbsp;
                {(employeeFlag ||
                  servicingUserRole === 'vendorsiteadmin' ||
                  servicingUserRole === 'vendorcontributor') &&
                !JSON.parse(sessionStorage.getItem('remote_user')) ? (
                  <span className="page-details-inline">
                    You can also leave a new message or respond to a customer
                    message.
                  </span>
                ) : (
                  <span className="page-details-inline">
                    You can also respond to messages from your U.S. Bancorp Impact Finance team members
                    or leave a new message.
                  </span>
                )}
              </div>
            </div>

            {/* ============= Reporting section ============= */}
            {reportResultsFull.length !== 0 || totalResults > 0 ? (
              <div className="report-download portfolio">
                <div className="report-download-title">Download a Report</div>
                {downloadDataCheck(reportResultsFull) ? (
                  <button
                    id='downloadReportBtn'
                    type="button"
                    className="download-link"
                    onClick={downloadPastDueReporting}
                  >
                    All past due reporting (30 days or more)
                  </button>
                ) : (
                  ''
                )}
                {totalResults > 0 ? (
                  <button
                    id='downloadReportBtn'
                    type="button"
                    className="download-link"
                    onClick={downloadAllReporting}
                  >
                    My Portfolio (all reporting)
                  </button>
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            )}
            {/* ============= Reporting section ends ============= */}
          </div>
          <div className="filter-by">Filter by:</div>
          <div className="sorting-inputs">
            
            {(employeeFlag ||
              servicingUserRole === 'vendorsiteadmin' ||
              servicingUserRole === 'vendorcontributor' ||
              servicingUserRole === 'unlistedvendor') &&
            !JSON.parse(sessionStorage.getItem('remote_user')) ? (
              <div className={parentCompany.length <=1 ? "autofilterDropdowns disabledDropdown" : "autofilterDropdowns"}>
                <p className="heading">Parent Company</p>
                <div className="inputWithButton">
                  <button
                    id='toggleParent'
                    type="button"
                    onClick={() => toggleContentParentCompany()}
                    className={parentCompany.length <=1 ? "dropbtn disabledDropdown" :"dropbtn"}
                    disabled={parentCompany.length <=1}
                  >
                    {' '}
                    &nbsp;{' '}
                    <img src={down} alt="down" className="down-image"></img>
                  </button>

                  <input
                    type="text"
                    className={parentCompany.length <=1 ? "dropdownelement disabledDropdown" :"dropdownelement"}
                    placeholder="Search by Company"
                    id="parentCompanyInput"
                    onChange={(e) =>
                      searchDropFilterParentCompany(e.target.value)
                    }
                    value={activeFilters.parentCompany}
                    disabled={parentCompany.length <=1}
                  />
                </div>
                {contentOpenParent ? (
                  <>
                    <div className="Autocomplete">
                      {!loading &&
                        filterParentCompany &&
                        filterParentCompany.length > 0 &&
                        filterParentCompany.map((item, index) => (
                          <div
                            key={index + 'p'}
                            className="auto-dropdown-items"
                            role="button"
                            tabIndex="0"
                            onKeyDown={(event) =>
                              compNameKepress(event, item.value)
                            }
                            onClick={() =>
                              loadByEntityName(
                                item.value,
                                'parentCompany',
                                activeFilters,
                                setActiveFilters,
                                reportResultsFull,
                                setReportResults,
                                setDashboardData,
                                dashboardData,
                                sortByValue,
                                setTotalPages,
                                setTotalResults,
                                searchValue,
                                loadFilterS,
                                // emptyFilters,
                                getAPIResponse
                              )
                            }
                          >
                            {/* {item.content} */}
                            {item.value}
                          </div>
                        ))}
                    </div>
                  </>
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            )}
            <div className={reportingEntity.length <=1 ? "autofilterDropdowns disabledDropdown" :"autofilterDropdowns"}>
              <p className="heading">Legal Entity</p>
              <div className="inputWithButton">
                <button
                  id='toggleEntity'
                  type="button"
                  onClick={() => toggleContent()}
                  className={reportingEntity.length <=1 ? "dropbtn disabledDropdown" :"dropbtn"}
                  disabled={reportingEntity.length <=1}
                >
                  {' '}
                  &nbsp;{' '}
                  <img src={down} alt="down" className="down-image"></img>
                </button>

                <input
                  type="text"
                  className={reportingEntity.length <=1 ? "dropdownelement disabledDropdown" :"dropdownelement"}
                  placeholder="Search by Entity"
                  id="legalEntityInput"
                  onChange={(e) => searchDropFilter(e.target.value)}
                  value={activeFilters.reportingEntity}
                  disabled={reportingEntity.length <=1}
                />
              </div>
              {contentOpen ? (
                <>
                  <div className="Autocomplete">
                    {!refreshUI && !loading && 
                      filterReportingEntity &&
                      filterReportingEntity.length > 0 &&
                      filterReportingEntity.map((item, index) => (
                        <div
                          key={index + 'l'}
                          className="auto-dropdown-items"
                          role="button"
                          tabIndex="0"
                          onKeyDown={(event) =>
                            compNameKepress(event, item.value)
                          }
                          onClick={() =>
                            loadByEntityName(
                              item.value,
                              'reportingEntity',
                              activeFilters,
                              setActiveFilters,
                              reportResultsFull,
                              setReportResults,
                              setDashboardData,
                              dashboardData,
                              sortByValue,
                              setTotalPages,
                              setTotalResults,
                              searchValue,
                              loadFilterS,
                              // emptyFilters,
                              getAPIResponse
                            )
                          }
                        >
                          {/* {item.content} */}
                          {item.value}
                        </div>
                      ))}
                  </div>
                </>
              ) : (
                ''
              )}
            </div>
            { (
              <div className={dealName.length <=1 ? "autofilterDropdowns disabledDropdown" : "autofilterDropdowns"}>
                <p className="heading">Deal Name</p>
                <div className="inputWithButton">
                  <button
                    id='toggleDeal'
                    type="button"
                    onClick={() => toggleContentDealName()}
                    className={dealName.length <=1 ? "dropbtn disabledDropdown" : "dropbtn"}
                    disabled={dealName.length <= 1}
                  >
                    {' '}
                    &nbsp;{' '}
                    <img src={down} alt="down" className="down-image"></img>
                  </button>

                  <input
                    type="text"
                    className={dealName.length <=1 ? "dropdownelement disabledDropdown" : "dropdownelement"}
                    placeholder="Search by DealName"
                    id="dealNameInput"
                    onChange={(e) => searchDropFilterDeal(e.target.value)}
                    value={activeFilters.dealName}
                    disabled={dealName.length <= 1}
                  />
                </div>
                {contentOpenDeal ? (
                  <>
                    <div className="Autocomplete">
                      {!loading &&
                        filterDealName &&
                        filterDealName.length > 0 &&
                        filterDealName.map((item, index) => (
                          <div
                            key={index + 'd'}
                            className="auto-dropdown-items"
                            role="button"
                            tabIndex="0"
                            onKeyDown={(event) =>
                              compNameKepress(event, item.value)
                            }
                            onClick={() =>
                              loadByEntityName(
                                item.value,
                                'dealName',
                                activeFilters,
                                setActiveFilters,
                                reportResultsFull,
                                setReportResults,
                                setDashboardData,
                                dashboardData,
                                sortByValue,
                                setTotalPages,
                                setTotalResults,
                                searchValue,
                                loadFilterS,
                                // emptyFilters,
                                getAPIResponse
                              )
                            }
                          >
                            {/* {item.content} */}
                            {item.value}
                          </div>
                        ))}
                    </div>
                  </>
                ) : (
                  ''
                )}
              </div>
            )}
            {
            employeeFlag &&
            !JSON.parse(sessionStorage.getItem('remote_user')) ? (
              <div className={syndicationFund.length <=1 ? "autofilterDropdowns disabledDropdown" :"autofilterDropdowns"}>
                <p className="heading">Fund Name</p>
                <div className="inputWithButton">
                  <button
                    id='toggleFund'
                    type="button"
                    onClick={() => toggleContentFund()}
                    className={syndicationFund.length <=1 ? "dropbtn disabledDropdown" : "dropbtn"}
                    disabled={syndicationFund.length <=1}
                  >
                    {' '}
                    &nbsp;{' '}
                    <img src={down} alt="down" className="down-image"></img>
                  </button>

                  <input
                    type="text"
                    className={syndicationFund.length <=1 ? "dropdownelement disabledDropdown" :"dropdownelement"}
                    placeholder="Search by FundName"
                    id="fundNameInput"
                    onChange={(e) => searchDropFilterFund(e.target.value)}
                    value={activeFilters.syndicationFundName}
                    disabled={syndicationFund.length <= 1}
                  />
                </div>
                {contentOpenFund ? (
                  <>
                    <div className="Autocomplete">
                      {!loading &&
                        filterFundName &&
                        filterFundName.length > 0 &&
                        filterFundName.map((item, index) => (
                          <div
                            key={index + 'f'}
                            className="auto-dropdown-items"
                            role="button"
                            tabIndex="0"
                            onKeyDown={(event) =>
                              compNameKepress(event, item.value)
                            }
                            onClick={() =>
                              loadByEntityName(
                                item.value,
                                'syndicationFundName',
                                activeFilters,
                                setActiveFilters,
                                reportResultsFull,
                                setReportResults,
                                setDashboardData,
                                dashboardData,
                                sortByValue,
                                setTotalPages,
                                setTotalResults,
                                searchValue,
                                loadFilterS,
                                // emptyFilters,
                                getAPIResponse
                              )
                            }
                          >
                            {/* {item.content} */}
                            {item.value}
                          </div>
                        ))}
                    </div>
                  </>
                ) : (
                  ''
                )}
              </div>
            ) : (
              ''
            )}

           
            {employeeFlag && showSyndication ? (
             
              
            <div className={syndicationFund.length <=1 ? "filterDropdowns disabledDropdown" :"filterDropdowns"}>
                <USBSelect
                  
                  id="fundname"
                  inputName="fundname"
                  initValue={activeFilters.syndicationFundName || undefined}
                  labelText="Fund name"
                  optionsArray={syndicationFund}
                  handleChange={(e) =>
                    filterData(
                      e,
                      'syndicationFundName',
                      setStatusData,
                      activeFilters,
                      setActiveFilters,
                      reportResultsFull,
                      setReportResults,
                      setDashboardData,
                      dashboardData,
                      sortByValue,
                      setTotalPages,
                      setTotalResults,
                      searchValue,
                      loadFilterS,
                      // emptyFilters,
                      getAPIResponse,
                      setRefreshUI
                    )
                  }
                  // ariaLabel="fund name"
                />
              </div>
            ) : (
              ''
            )}
            <div className="filterDropdowns">
              {!loading && <USBSelect
                id="documenttype"
                name="documenttype"
                initValue={activeFilters.requirementName}
                labelText="Document type"
                optionsArray={requirementName}
                handleChange={(e) =>
                  filterData(
                    e,
                    'requirementName',
                    setStatusData,
                    activeFilters,
                    setActiveFilters,
                    reportResultsFull,
                    setReportResults,
                    setDashboardData,
                    dashboardData,
                    sortByValue,
                    setTotalPages,
                    setTotalResults,
                    searchValue,
                    loadFilterS,
                    // emptyFilters,
                    getAPIResponse,
                    setRefreshUI
                  )
                }
                // ariaLabel="document type"
              /> }
            </div>
            <div className="filterDropdowns">
              <USBSelect
                id="status"
                name="status"
                initValue={activeFilters.status || undefined}
                labelText="Status"
                optionsArray={statusDrop}
                handleChange={(e) =>
                  filterData(
                    e,
                    'status',
                    setStatusData,
                    activeFilters,
                    setActiveFilters,
                    reportResultsFull,
                    setReportResults,
                    setDashboardData,
                    dashboardData,
                    sortByValue,
                    setTotalPages,
                    setTotalResults,
                    searchValue,
                    loadFilterS,
                    // emptyFilters,
                    getAPIResponse,
                    setRefreshUI
                  )
                }
                // ariaLabel="status"
              />
            </div>
            {employeeFlag && !sessionStorage.getItem('remote_user') ? (
              <div className="filterDropdowns">
                <USBSelect
                  id="follow"
                  name="follow"
                  initValue={activeFilters.following || undefined}
                  labelText="Following"
                  optionsArray={followCheck}
                  handleChange={(e) =>
                    filterData(
                      e,
                      'followCheck',
                      setStatusData,
                      activeFilters,
                      setActiveFilters,
                      reportResultsFull,
                      setReportResults,
                      setDashboardData,
                      dashboardData,
                      sortByValue,
                      setTotalPages,
                      setTotalResults,
                      searchValue,
                      loadFilterS,
                      // emptyFilters,
                      getAPIResponse,
                      setRefreshUI
                    )
                  }
                  // ariaLabel="status"
                />
              </div>
            ) : (
              ''
            )}
            
            {employeeFlag ||
            servicingUserRole === 'vendorsiteadmin' ||
            servicingUserRole === 'vendorcontributor' ||
            servicingUserRole === 'unlistedvendor' ||
            servicingUserRole === 'siteadmin' ||
            servicingUserRole === 'contributor' ||
            sessionStorage.getItem('userrole') === 'portaladmin' ||
            sessionStorage.getItem('userrole') === 'customer' ||
            sessionStorage.getItem('userrole') === 'employee' ||
            servicingUserRole === 'customer' ? (
              <div className="datefilterDropdowns">
                { !loading && <USBDatePicker
                  id="asofdate"
                  inputName="asofdate"
                  initValue={activeFilters.asOfDate || undefined}
                  labelText2="As of Date"
                  statusUpdateCallback={(e) => {
                    loadByEntityName(
                      activeFilters.parentCompany,
                      'parentCompany',
                      activeFilters,
                      setActiveFilters,
                      reportResultsFull,
                      setReportResults,
                      setDashboardData,
                      dashboardData,
                      sortByValue,
                      setTotalPages,
                      setTotalResults,
                      searchValue,
                      loadFilterS,
                      // emptyFilters,
                      getAPIResponse,
                      false
                    );


                    // if(e.event=="onChange" ||e.event=="dynamicValue")
                    filterData(
                      e,
                      'asOfDate',
                      setStatusData,
                      activeFilters,
                      setActiveFilters,
                      reportResultsFull,
                      setReportResults,
                      setDashboardData,
                      dashboardData,
                      sortByValue,
                      setTotalPages,
                      setTotalResults,
                      searchValue,
                      loadFilterS,
                      // emptyFilters,
                      getAPIResponse,
                      setRefreshUI
                    );
                  }
                  }
                  settings={{
                    dateInput: {
                      ...defaultSettingsDateInput1,
                    },
                    calendar: {
                      id: 'datepicker',
                      ...defaultCalendarSettings,
                      ...defaultSettingsCalendar1,
                      occurrence: 'both',
                      numberOfYearsToShow: '20',
                      labelText: 'As of Date',
                    },
                  }}
                  content={{
                    ...defaultContent1,
                    labelText: 'Start date',
                    inputName: 'asofdate',
                  }}
                /> }
              </div>
            ) : (
              ''
            )}
            {(employeeFlag ||
            servicingUserRole === 'vendorsiteadmin' ||
            servicingUserRole === 'vendorcontributor' ||
            servicingUserRole === 'unlistedvendor' ||
            servicingUserRole === 'siteadmin' ||
            servicingUserRole === 'contributor' ||
            sessionStorage.getItem('userrole') === 'portaladmin' ||
            sessionStorage.getItem('userrole') === 'customer' ||
            sessionStorage.getItem('userrole') === 'employee' ||
            servicingUserRole === 'customer') && includesCBDocs ? (
              <div className="datefilterDropdowns">
                { !loading && <USBDatePicker
                  id="cbDate"
                  inputName="cbDate"
                  initValue={activeFilters.cbDate || undefined}
                  labelText2="Closing Binder Date"
                  statusUpdateCallback={(e) => {

                    loadByEntityName(
                      activeFilters.parentCompany,
                      'parentCompany',
                      activeFilters,
                      setActiveFilters,
                      reportResultsFull,
                      setReportResults,
                      setDashboardData,
                      dashboardData,
                      sortByValue,
                      setTotalPages,
                      setTotalResults,
                      searchValue,
                      loadFilterS,
                      // emptyFilters,
                      getAPIResponse,
                      false
                    );


                    // if(e.event=="onChange" ||e.event=="dynamicValue")
                    filterData(
                      e,
                      'cbDate',
                      setStatusData,
                      activeFilters,
                      setActiveFilters,
                      reportResultsFull,
                      setReportResults,
                      setDashboardData,
                      dashboardData,
                      sortByValue,
                      setTotalPages,
                      setTotalResults,
                      searchValue,
                      loadFilterS,
                      // emptyFilters,
                      getAPIResponse,
                      setRefreshUI
                    );
                  }
                  }
                  settings={{
                    dateInput: {
                      ...defaultSettingsDateInput1,
                      initValue : activeFilters?.cbDate || undefined,
                    },
                    calendar: {
                      id: 'datepicker',
                      ...defaultCalendarSettings,
                      ...defaultSettingsCalendar1,
                      occurrence: 'both',
                      numberOfYearsToShow: '20',
                      labelText: 'Closing Binder Date',
                    },
                  }}
                  content={{
                    dateInput: {
                      calendarButtonAriaLabel: 'Choose date',
                      helperText: 'mm/dd/yyyy',
                      helperTextOptional: 'Optional',
                      labelText: 'Closing Binder Date',
                      errorMessages: {
                        default: 'Please enter a valid date.',
                        118: 'Please enter a valid date.',
                        201: 'Please enter a valid date.',
                        202: 'Date should be in the past.',
                        203: 'Date should be in the future.',
                        221: 'Enter no more than 10 characters.',
                        213: 'Enter numbers only.',
                        224: '(Optional field)',
                        228: "That date isn't available. Please try again.",
                      },
                    },
                  }}
                /> }
              </div>
            ) : (
              ''
            )}

            {(employeeFlag ||
              servicingUserRole === 'vendorsiteadmin' ||
              servicingUserRole === 'vendorcontributor' ||
              servicingUserRole === 'unlistedvendor' ||
              servicingUserRole === 'siteadmin' ||
              servicingUserRole === 'contributor' ||
              sessionStorage.getItem('userrole') === 'portaladmin' ||
            sessionStorage.getItem('userrole') === 'customer' ||
            sessionStorage.getItem('userrole') === 'employee' ||
              servicingUserRole === 'customer') &&
            activeFilters.status !== 'Not Submitted' ? (
              <>
                <div className="datefilterDropdowns">
                  { !loading && <USBDatePicker
                    id="submitteddate"
                    inputName="submitteddate"
                    initValue={activeFilters?.submittedDate?.length==10 ? activeFilters?.submittedDate : undefined}
                    labelText="Received Date"
                    statusUpdateCallback={(e) => 
                      {
                      // if(e.event=="onChange" ||e.event=="dynamicValue")
                      filterData(
                        e,
                        'submittedDate',
                        setStatusData,
                        activeFilters,
                        setActiveFilters,
                        reportResultsFull,
                        setReportResults,
                        setDashboardData,
                        dashboardData,
                        sortByValue,
                        setTotalPages,
                        setTotalResults,
                        searchValue,
                        loadFilterS,
                        // emptyFilters,
                        getAPIResponse,
                        setRefreshUI
                      )
                    }
                  }
                    settings={{
                      dateInput: {
                        ...defaultSettingsDateInput,
                      },
                      calendar: {
                        id: 'datepicker',
                        ...defaultCalendarSettings,
                        ...defaultSettingsCalendar,
                        occurrence: 'past',
                        numberOfYearsToShow: '20',
                        labelText: 'Received Date',
                      },
                    }}
                    content={{
                      ...defaultContent,
                      labelText: 'Start date',
                      inputName: 'submitteddate',
                    }}
                  /> }
                </div>
              </>
            ) : (
              ''
            )}
             
            </div>
            <div className="clearFilter">
              <USBButton
                id="clearfilter"
                name="clearfilter"
                variant="utility"
                className="clear-filter"
                handleClick={() => {
                  setStatusData((prev)=>{
                    if (sessionStorage.getItem('userrole') === 'employee' && !JSON.parse(sessionStorage.getItem('remote_user'))){
                      return 'Submitted'
                    } else {
                      return 'Not Submitted'
                    }
                  })
                  setSearchItemsList([]);
                  setSearchValue('');
                  setSearchMenuKey((prev) => prev + 1);
                  clearFilter(sessionStorage.getItem('assignedUser'));
                  // window.location.href = '/ReportingDashboard';
                }}
              >
                Clear filters
              </USBButton>
            </div>
            <div className="filterDropdowns">
            <USBMenu id='sortByDropdown' type='single'>
                <USBMenu.Button>Sort By</USBMenu.Button>
                <USBMenu.List onChange={(items)=>{sortFilteredData(
                    items,
                    reportResults,
                    setReportResults,
                    setSortByValue,
                    setTotalPages,
                    setTotalResults,
                    sortBy
                  )}}>
                    { sortBy.map((item)=>{
                      return <USBMenu.Item key={item.label} >{item.label}</USBMenu.Item>
                    })}
                </USBMenu.List>
            </USBMenu>

              {/* <USBDropdown
                label="Sort by"
                name='sortByDropdown'
                id='sortByDropdown'
                inputId="sortByInput"
                value={sortByValue}
                items={sortBy}
                placeholder="Sort by"
                handleChange={(e) =>
                  sortFilteredData(
                    e,
                    reportResults,
                    setReportResults,
                    setSortByValue,
                    setTotalPages,
                    setTotalResults
                  )
                }
                ariaLabel="sort by"
              /> */}
            </div>
          
          <div className="totalresultsno">
           
            &nbsp;{totalResults} results.
          </div>

          <div className="page-content-dashboard">
            {reportResults.length === 0 && !loading ? (
              <div className="no-records-message">
                <p>No records found. Please adjust your filters.</p>
              </div>
            ) : (
            activeFilters?.status != 'Not Submitted' ||
            activeFilters?.status == 'Status'
              ? !loading && (
                  <USBTable
                    currentPageIndex={currentPage}
                    handlePageChange={(e)=> {
                      setTimeout(() => {
                        setCurrentPageTemp(e)
                      }, 500);
                    }
                    }
                    addClasses="pagination-container-dashboard"
                    displayVariant="auto"
                    useBorder="true"
                    paginationOptions={rangeArray}
                    handleItemCountChange={(itemCount) =>
                      updateRangeArray(itemCount)
                    }
                    labelText=""
                    paginationLabels={{
                      previousButton: 'Previous page',
                      nextButton: 'Next page',
                      unit: 'Page',
                      preposition: 'of',
                      rowDropdown: '',
                    }}
                    paginationPosition="both"
                    onRowClick={(row) => row?.rowHref && (window.location.href = row.rowHref)}
                    columnData={
                      !sessionStorage.getItem('remote_user') && tempUserRole === 'employee'
                        ? [
                            {
                              headerName: 'Due Date',
                              fieldFor: 'first',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Deal/Fund Name',
                              fieldFor: 'second',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Legal Entity',
                              fieldFor: 'third',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Document Type',
                              fieldFor: 'fourth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: includesCBDocs ? 'As of Date / Closing Binder Date' : 'As of Date',
                              fieldFor: 'fifth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Received Date',
                              fieldFor: 'sixth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Status',
                              fieldFor: 'seventh',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Follow',
                              fieldFor: 'eighth',
                              disableRowClick: true,
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            }
                          ]
                        : [
                            {
                              headerName: 'Due Date',
                              fieldFor: 'first',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Deal/Fund Name',
                              fieldFor: 'second',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Legal Entity',
                              fieldFor: 'third',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Document Type',
                              fieldFor: 'fourth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: includesCBDocs ? 'As of Date / Closing Binder Date' :'As of Date',
                              fieldFor: 'fifth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Received Date',
                              fieldFor: 'sixth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Status',
                              fieldFor: 'seventh',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            }
                          ]
                    }
                    tableData={
                      reportResults.length != 0
                        ? paginationtableData(
                            reportResults,
                            activeFilters.status,
                            tempUserRole,
                            setLoading,setActionsDrop,setCurrentPage,currentPageTemp,closingBinderCategoryLookup
                          )
                        : !sessionStorage.getItem('remote_user') && tempUserRole === 'employee' ? [ 
                            {
                              first: '-',
                              second: '-',
                              third: '-',
                              fourth: '-',
                              fifth: '-',
                              sixth: '-',
                              seventh: '-',
                              eighth: '-',
                              ninth: '-'
                            },
                          ] : [{
                            first: '-',
                            second: '-',
                            third: '-',
                            fourth: '-',
                            fifth: '-',
                            sixth: '-',
                            seventh: '-',
                            eighth: '-',
                          },
                        ]
                    }
                  />
                )
              : !loading && (
                  <USBTable
                  currentPageIndex={currentPage}
                    handlePageChange={(e)=> {
                      setTimeout(() => {
                        setCurrentPageTemp(e)
                      }, 100);
                    }
                    }
                    addClasses="pagination-container-dashboard"
                    displayVariant="auto"
                    useBorder="true"
                    paginationOptions={rangeArray}
                    handleItemCountChange={(itemCount) =>
                      updateRangeArray(itemCount)
                    }
                    paginationLabels={{
                      previousButton: 'Previous page',
                      nextButton: 'Next page',
                      unit: 'Page',
                      preposition: 'of',
                      rowDropdown: '',
                    }}
                    paginationPosition="both"
                    onRowClick={(row) => row?.rowHref && (window.location.href = row.rowHref)}
                    columnData={
                      sessionStorage.getItem('userrole') === 'employee' &&
                      !sessionStorage.getItem('remote_user')
                        ? [
                            {
                              headerName: 'Due Date',
                              fieldFor: 'first',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Deal/Fund Name',
                              fieldFor: 'second',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Legal Entity',
                              fieldFor: 'third',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Document Type',
                              fieldFor: 'fourth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: includesCBDocs ? 'As of Date / Closing Binder Date' :'As of Date',
                              fieldFor: 'fifth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Status',
                              fieldFor: 'sixth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Follow',
                              fieldFor: 'seventh',
                              disableRowClick: true,
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                          ]
                        : [
                            {
                              headerName: 'Due Date',
                              fieldFor: 'first',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Deal/Fund Name',
                              fieldFor: 'second',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Legal Entity',
                              fieldFor: 'third',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Document Type',
                              fieldFor: 'fourth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: includesCBDocs ? 'As of Date / Closing Binder Date' :'As of Date',
                              fieldFor: 'fifth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                            {
                              headerName: 'Status',
                              fieldFor: 'sixth',
                              isSortable: false,
                              wrapContent: true,
                              dataType: 'node',
                              sortValues: ['Oldest', 'Newest'],
                              headerAlignment: 'left',
                            },
                          ]
                    }
                    tableData={
                      reportResults.length != 0
                        ? paginationtableData(
                            reportResults,
                            activeFilters.status,
                            tempUserRole,setLoading,setActionsDrop,setCurrentPage,currentPageTemp,closingBinderCategoryLookup
                          )
                        : !sessionStorage.getItem('remote_user') && tempUserRole === 'employee' ? [
                            {
                              first: '-',
                              second: '-',
                              third: '-',
                              fourth: '-',
                              fifth: '-',
                              sixth: '-',
                              seventh: '-',
                              eighth: '-',
                            },
                          ] : [
                            {
                              first: '-',
                              second: '-',
                              third: '-',
                              fourth: '-',
                              fifth: '-',
                              sixth: '-',
                              seventh: '-',
                            },
                          ]
                    }
                  />
                )
            )}
          </div>
        </USBColumn>
      </USBGrid>)
      }
    </>
  );
};

export default ReportingDashboard;